import { ChangeEvent } from 'react';
import { FormRadio, RadioGroup } from '@tryhackme/thm-ui-components';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { store } from 'src/app/store';
import { addCategory, removeAddedCategory, updateRoomCategory } from 'src/app/reducers/manage-room.reducer';
import { ToolTip } from 'src/common/components/tool-tip';
import { StyledAddButton, StyledCategoryTagsCardContainer, StyledCategoryLabel, StyledFormLabel, StyledHeaderWrapper, StyledIdTag, StyledInfoContainer, StyledLine, StyledRadioWrapper, StyledRemoveButton, StyledSourceTag, StyledTrashIcon } from './categories-tags-card.styles';
import { CategoriesTagsCardProps } from './categories-tags-card.types';
import { CategoryCardWeightInputs } from './categories-tags-card.constants';
export const CategoryTagsCard = ({
  category,
  isCategoryAdded = false
}: CategoriesTagsCardProps) => {
  const {
    label,
    info,
    weight = 1,
    parentsId = []
  } = category ?? {};
  const handleAddCategory = () => {
    store.dispatch(addCategory({
      ...category,
      weight: 1
    }));
  };
  const handleUpdateCategory = (e: ChangeEvent<HTMLInputElement>) => {
    store.dispatch(updateRoomCategory({
      ...category,
      weight: Number(e.target.value)
    }));
  };
  const handleRemoveAddedCategory = () => {
    store.dispatch(removeAddedCategory(category));
  };
  return <StyledCategoryTagsCardContainer data-sentry-element="StyledCategoryTagsCardContainer" data-sentry-component="CategoryTagsCard" data-sentry-source-file="category-tags-card.tsx">
      <StyledHeaderWrapper data-sentry-element="StyledHeaderWrapper" data-sentry-source-file="category-tags-card.tsx">
        <StyledCategoryLabel data-sentry-element="StyledCategoryLabel" data-sentry-source-file="category-tags-card.tsx">{label}</StyledCategoryLabel>
        {isCategoryAdded ? <StyledRemoveButton color="secondary" onClick={handleRemoveAddedCategory}>
            <StyledTrashIcon icon={faTrashCan} />
            Remove
          </StyledRemoveButton> : <StyledAddButton color="secondary" onClick={handleAddCategory}>
            <FontAwesomeIcon icon={faPlus} />
            Add
          </StyledAddButton>}
      </StyledHeaderWrapper>

      {info && <StyledInfoContainer>
          {parentsId?.map(item => <StyledSourceTag key={item._id}>{item?.label}</StyledSourceTag>)}

          <StyledIdTag>{info?.id}</StyledIdTag>
        </StyledInfoContainer>}

      {isCategoryAdded && <>
          <StyledLine />

          <StyledRadioWrapper>
            <StyledFormLabel>Rating:</StyledFormLabel>
            <RadioGroup legend="" horizontal>
              {CategoryCardWeightInputs.map(input => <ToolTip key={input.id} toolTipText={input.toolTipText}>
                  <FormRadio checked={weight === Number(input.value)} id={`${input.id}-${label}`} data-testid={`${input.id}-${label}`} label={input.label} value={input.value} name={`${input.name}-${label}`} onChange={handleUpdateCategory} />
                </ToolTip>)}
            </RadioGroup>
          </StyledRadioWrapper>
        </>}
    </StyledCategoryTagsCardContainer>;
};